export const appEmailIcon = {
  data: `<svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M20.5222 4H3.47782C2.12628 4 1 5.30435 1 6.86957V17.1304C1 18.6957 2.12628 20 3.47782 20C10.2258 20 14.0108 20 20.5222 20C21.8737 20 23 18.6957 23 17.1304V6.86957C23 5.30435 21.9488 4 20.5222 4Z" fill="currentColor"/><path d="M5 9L12 13L19 9" stroke="white" stroke-width="3" stroke-linecap="round" stroke-linejoin="round"/></svg>`,
  name: 'email',
};
